// eslint-disable-next-line import/no-anonymous-default-export
export default{ 
    Main: {
        btn1: "Hepsi",
        btn2: "Ana Yemekler",
        btn3: "İçecekler",
        btn4: "Antre",
        btn5: "Tatlılar", 
        btn6: "Salatalar", 
        btn7: "Kahvaltılar", 
        btn8: "Nargile", 
    },
    Salad: {
        saladIsim1: "Ton Balıklı Salata",
        saladIcerik1:"Çeri domates, zeytin, kırmızı soğan, mısır, kapari, salatalık",
        saladIsim2: "Teriyaki Tavuk Salata",
        saladIcerik2:"Mısır, Çeri domates",
        saladIsim3: "Karidesli Avokadolu Salata",
        saladIcerik3:"Avakoda, mısır, çeri domates",
        saladIsim4: "Domatesli Peynirli Salata",
        saladIcerik4:"Domates, salatalık, beyaz peynir, soğan, mısır, zeytin",
    },
    Breakfast: {
        breakfastIsim1:"Menemen",
        breakfastIcerik1:"",
        breakfastIsim2:"Serpme Kahvaltı",
        breakfastIcerik2:"Sosis, sigara böreği, patates kızartması, bal, reçel, tereyağ, beyaz peynir, kaşar, zeytin, salatalık, domates, haşlanmış yumurta",
        breakfastIsim3:"Kavurmalı Yumurta",
        breakfastIcerik3:"Kavurma, Yumurta",
        breakfastIsim4:"Pastırmalı Yumurta",
        breakfastIcerik4:"Pastırma, Yumurta",
    },
    Desserts: {
        tatliIsim1: "Cheesecake",
        tatliIcerik1: "Çikolata, Frambuaz",
        tatliIsim2: "Sufle",
        tatliIcerik2: "- Dondurma ile sunulur",
        tatliIsim3: "Panna Cotta",
        tatliIcerik3: "Frambuaz",
        tatliIsim4: "Cornetto",
        tatliIcerik4: "Dondurma",
        tatliIsim5: "Magnum",
        tatliIcerik5: "Dondurma",
    },
    Drinks: {
        icecek1: "Cola Zero",
        icecek2: "Cola",
        icecek3: "Fanta",
        icecek4: "Sprite",
        icecek5: "Gazoz",
        icecek6: "Fusetea",
        icecek7: "Capy",
        icecek8: "Cola 1LT",
        icecek9: "Sprite 1LT",
        icecek10: "Fanta 1LT",  
        icecek11: "Soda",
        icecek12: "Meyveli Soda",
        icecek13: "Redbull",
        icecek14: "Çay",
        icecek15: "Oralet",
        icecek16: "Nescafe",
        icecek17: "Türk Kahvesi",
        icecek18: "Su",
        icecek19: "Ayran",
        icecek20: "Fincan Çay",
        icecek21: "Şişe Kola",
        icecek22: "Schweppes",
        icecek23: "Nescafe Çeşitleri",
        icecek24: "Şalgam",
},
    Antre: {
        antreIsim1: "Patates Tava",
        AntreIcerik1: "-", 
        antreIsim2: "Fırında Kaşarlı Mantar",
        AntreIcerik2: "-", 
        antreIsim3: "Duble Patates Tava",
        AntreIcerik3: "-", 
        antreIsim4: "Karides Güveç",
        AntreIcerik4: "-", 
        antreIsim5: "Soğan Halkası",
        AntreIcerik5: "-", 
        antreIsim6: "Kalamar Tava",
        AntreIcerik6: "-", 
        antreIsim7: "Sigara Böreği",
        AntreIcerik7: "- 8 Tane", 
        antreIsim8: "Atıştırma Tabağı",
        AntreIcerik8: "Patates kızarması,Sosis,Sogan halkası, Sigara böregi, Nugget, Kaşar pane", 
        antreIsim9: "Tavuk Kanat",
        AntreIcerik9: "- Acılı sos, patates kızartması ile sunulur",
    },
    Course: {
        mnBaslik1: "Pizza Çeşitleri",
        anaYemekIsim1: "Margarita Pizza",
        anaYemekIcerik1: "Mozarella, dilim domates",
        anaYemekIsim2: "Karışık Pizza",
        anaYemekIcerik2: "Salam, sosis, sucuk, mantar, yeşil zeytin, biber, mısır, siyah zeytin",
        anaYemekIsim3: "Ton Balıklı Pizza",
        anaYemekIcerik3: "Ton balığı, soğan, biber,yeşil zeytin, mısır, siyah zeytin",
        anaYemekIsim4: "Tavuklu BBQ Soslu Pizza",
        anaYemekIcerik4: "Mısır, biber, soğan, kapya biber",
        anaYemekIsim5: "Bolonez Pizza",
        anaYemekIcerik5: "Kıyma, Mozarella",
        mnBaslik2: "Tost Çeşitleri",
        anaYemekIsim6: "Karışık Tost",
        anaYemekIcerik6: " - Domates ve salatalık ile sunulur",
        anaYemekIsim7: "Kaşarlı Tost",
        anaYemekIcerik7: "- Domates ve salatalık ile sunulur",
        anaYemekIsim8: "Çift Kaşarlı Tost",
        anaYemekIcerik8: "- Domates ve salatalık ile sunulur",
        mnBaslik3: "Taco Çeşitleri",
        anaYemekIsim9: "Etli Taco",
        anaYemekIcerik9: "Kıyma, soğan, havuç, sebze, mantar - patates kızartması, chilli sos ile sunulur.",
        anaYemekIsim10: "Tavuklu Taco",
        anaYemekIcerik10: "Tavuk, soğan, havuç, sebze, mantar - patates kızartması, chilli sos ile sunulur.",
        anaYemekIsim11: "Karidesli Taco",
        anaYemekIcerik11: "Karides, soğan, havuç, sebze, mantar - patates kızartması, chilli sos ile sunulur.",
        mnBaslik4: "Izgara Çeşitleri",
        anaYemekIsim12: "Tavuk Şiş",
        anaYemekIcerik12: "- Pilav, patates Kızartması ile sunulur",
        anaYemekIsim13: "Antrikot",
        anaYemekIcerik13: "- Patates Kızartması ile sunulur",
        anaYemekIsim14: "Köfte Porsiyon",
        anaYemekIcerik14: "- Pilav, patates Kızartması ile sunulur",
        anaYemekIsim15: "Ekmek Arası Köfte",
        anaYemekIcerik15: "-",
        // ON ALTI YOK
        mnBaslik5: "Burger Çeşitleri",
        anaYemekIsim17: "Hamburger",
        anaYemekIcerik17: "- 120 gramdır.",
        anaYemekIsim18: "Cheese Burger",
        anaYemekIcerik18: "- 120 gramdır",
        anaYemekIsim19: "Tavuk Burger",
        anaYemekIcerik19: "- 120 gramdır",
        anaYemekIsim20: "Hamburger Menü",
        anaYemekIcerik20: "120 gramdır - Patates kızartması ve kola ile sunulur",
        anaYemekIsim21: "Cheese Burger Menü",
        anaYemekIcerik21: "120 gramdır - Patates kızartması ve kola ile sunulur",
        anaYemekIsim22: "Tavuk Burger Menü",
        anaYemekIcerik22: "120 gramdır - Patates kızartması ve kola ile sunulur",
        mnBaslik6: "Tavuk Yemekleri",
        anaYemekIsim23: "Mantar Soslu Tavuk",
        anaYemekIcerik23: "- Püre ile sunulur",
        anaYemekIsim24: "Köri Soslu Tavuk",
        anaYemekIcerik24: "- Pilav ve yeşillik ile sunulur",
        anaYemekIsim25: "Şinitzel Tabağı",
        anaYemekIcerik25: "- Patates kızartması ile sunulur",
        mnBaslik7: "Makarna Çeşitleri",
        anaYemekIsim26: "Spagetti Bolonez",
        anaYemekIcerik26: "-",
        anaYemekIsim27: "Penne Arabiata",
        anaYemekIcerik27: "Sarımsak, zeytin, domates sos",
        anaYemekIsim28: "Körili Tavuklu Penne",
        anaYemekIcerik28: "Mantar, Krema",
        anaYemekIsim29: "Pesto Soslu Kremalı Penne",
        anaYemekIcerik29: "Mantar",
        anaYemekIsim30: "Kremalı Karidesli Linguni",
        anaYemekIcerik30: "-",
        anaYemekIsim31: "Mantı",
        anaYemekIcerik31: "-",
        anaYemekIsim32: "Cevizli Mantı",
        anaYemekIcerik32: "-", 
        anaYemekIsim33: "Fettucini Kremalı Tavuk Mantar",
        anaYemekIcerik33: "-", 
        mnBaslik8: "Dürüm Çeşitleri",
        anaYemekIsim34: "Tavuk Wrap",
        anaYemekIcerik34: "Tavuk, biber, soğan, mantar, kaşar, chilli sos",
        anaYemekIsim35: "Et Wrap",
        anaYemekIcerik35: "Et, biber, soğan, mantar, kaşar, chilli sos",  
        mnBaslik9: "Balık Çeşitleri",
        anaYemekIsim36: "Barbun",
        anaYemekIcerik36: "500 gramdır",
        anaYemekIsim37: "Çupra",
        anaYemekIcerik37: "300-400 gram arasıdır.",
          
    },
    Other: {
        otherIsim1: "Karışık Nargile",
        otherIcerik1: "",
        otherIsim2: "Muz Çilek Nargile",
        otherIcerik2: "Muzlu, Çilekli",
        otherIsim3: "Lady Killer",
        otherIcerik3: "",
        otherIsim4: "Lav 66",
        otherIcerik4: "",
        otherIsim5: "Elmalı Nargile",
        otherIcerik5: "",
    }
  }